import { ScheduleTestID } from "@/constants/TestID";
import type { AvatarCardProps } from "@/ui/core/AvatarCard";
import AvatarCard from "@/ui/core/AvatarCard";
import Text from "@/ui/core/Text";
import { VStack } from "@/ui/layout";
import { joinTestIDs, pluralize } from "@/utils/string.util";

interface EventDetailsAttendeeListProps {
  attendees?: AvatarCardProps[];
  isGroupClassEvent: boolean;
}

const baseTestID = joinTestIDs(
  ScheduleTestID.ScheduleEventDetails,
  "attendee-list",
);

const EventDetailsAttendeeList = ({
  attendees,
  isGroupClassEvent,
}: EventDetailsAttendeeListProps) => {
  const itemCount = attendees?.length ?? 0;
  const groupClassTitle = itemCount > 0 ? "Hosted by" : "";
  const eventTitle = `${itemCount} attendee${pluralize({ itemCount })}`;

  const title = isGroupClassEvent ? groupClassTitle : eventTitle;
  return (
    <VStack gap={12} marginVertical={24} testID={baseTestID}>
      <Text testID={joinTestIDs(baseTestID, "title")} variant="captionMedium">
        {title}
      </Text>
      {attendees?.map((attendee) => (
        <AvatarCard
          key={attendee.userId}
          overflowBehavior="wrap"
          pronouns={attendee.pronouns}
          subtitle={attendee.subtitle}
          userId={attendee.userId}
          userName={attendee.userName}
          userType={attendee.userType}
        />
      ))}
    </VStack>
  );
};

export type { EventDetailsAttendeeListProps };
export default EventDetailsAttendeeList;
